  import {
    FETCH_MASTER_CODES_REQUEST,
    FETCH_MASTER_CODES_SUCCESS,
    FETCH_MASTER_CODES_FAILURE,
    CREATE_OR_UPDATE_MASTER_CODE_REQUEST,
    CREATE_OR_UPDATE_MASTER_CODE_SUCCESS,
    CREATE_OR_UPDATE_MASTER_CODE_FAILURE,
} from "../actions/Types";
  
  const initialState = {
    loading: false,
    error: null,
    success: false,
    masterCodes: [],
  };
  
   const MasterCodesReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_MASTER_CODES_REQUEST:
            case CREATE_OR_UPDATE_MASTER_CODE_REQUEST:
              return {
                ...state,
                loading: true,
                success: false,
                error: null,
              };
        
            case FETCH_MASTER_CODES_SUCCESS:
              return {
                ...state,
                loading: false,
                masterCodes: action.payload,
              };
        
            case CREATE_OR_UPDATE_MASTER_CODE_SUCCESS:
              return {
                ...state,
                loading: false,
                success: true,
              };
        
            case FETCH_MASTER_CODES_FAILURE:
            case CREATE_OR_UPDATE_MASTER_CODE_FAILURE:
              return {
                ...state,
                loading: false,
                error: action.payload,
              };
      default:
        return state;
    }
  };

  export default MasterCodesReducer;
  